module.exports = __webpack_public_path__ + "img/picture_in_picture_alt.66dba123.svg";